import React from "react";
import RichTextBody from "/src/components/RichTextBody";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as styles from "/src/css/resourcePage.module.css";
import Seo from "/src/components/Seo";
import Layout from "/src/components/Layout";
import { FaUserCircle } from "@react-icons/all-files/fa/FaUserCircle";
import { useState } from "react";
import FormModal from "/src/components/FormModal";
import { v4 as uuidv4 } from "uuid";

const ProjectDetail = (props) => {
  const { createdAt, createdBy, description, title, isTakingVolunteers } =
    props.pageContext.node;
  const imagesArray = props.pageContext.node.images;

  let formattedDate = new Date(createdAt);
  formattedDate =
    formattedDate.getDate() +
    " " +
    formattedDate.toLocaleString("default", { month: "long" }).substring(0, 3) +
    " '" +
    formattedDate.getFullYear().toString().substring(2);

  const [viewModal, setViewModal] = useState(false);
  const hideModalHandler = () => setViewModal(false);

  return (
    <>
      <Seo title={title} />
      <div className={`center ${styles.page}`}>
        <div className={styles.pageBoundary}>
          <div className={styles.topSection}>
            <div>
              <h1 className={`${styles.pageHeader}`}>{title}</h1>
              <div className={`${styles.metadata} pv-10`}>
                <FaUserCircle className={styles.profileIcon} />
                <div className={styles.author}>{createdBy}</div>
                <div className={styles.createdAt}>{formattedDate}</div>
              </div>
            </div>
            {isTakingVolunteers ? (
              <button
                onClick={() => setViewModal(true)}
                className={styles.signUpButton}
              >
                Join us now!
              </button>
            ) : null}
          </div>
          {viewModal && <FormModal cancel={hideModalHandler} name={title} />}

          <div>
            {imagesArray.map((image) => (
              <div key={uuidv4()}>
                <GatsbyImage
                  image={getImage(image.gatsbyImageData)}
                  alt={image.title}
                />
                <div className={styles.imgDescription}>{image.description}</div>
              </div>
            ))}
          </div>

          <div className={styles.fullContent}>
            <RichTextBody content={description} />
          </div>
        </div>
      </div>
    </>
  );
};
ProjectDetail.Layout = Layout;
export default ProjectDetail;
